// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PZ-t","top":"styles_top__1Jn_c","left":"styles_left__2s_1e","description":"styles_description__369wM"};